import { render, staticRenderFns } from "./room-rent-out.vue?vue&type=template&id=5ed5b6c2&scoped=true"
import script from "./room-rent-out.vue?vue&type=script&lang=js"
export * from "./room-rent-out.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5b6c2",
  null
  
)

export default component.exports